import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { EditCategoryAsync } from "services/categories";
import i18next from "i18next";

export default function EditCategory() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(EditCategoryAsync, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم التعديل بنجاح"
                : "Updated successfullys",
          });
          queryClient.invalidateQueries("categories-selector");
        }
      },
    }),
  };
}
